import React from 'react';
import PropTypes from 'prop-types';
import { darken, makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import cn from 'classnames';
import { borderRadius, colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    border: `1px solid ${colors.fieldsBorderGray}`,
    borderRadius: borderRadius.fields,
    backgroundColor: darken(colors.background.grayLight, 0.1),
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',
    lineHeight: 1.2,
  },
  infoIcon: {
    fill: colors.fieldsBorderGray,
    margin: theme.spacing(0, 2, 0, 1),
  },
}));

const DisclaimerBox = ({ text, className }) => {
  const classes = useStyles();
  return (
    <div className={cn(classes.root, className)}>
      <InfoIcon className={classes.infoIcon} /> {text}
    </div>
  );
};

DisclaimerBox.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default DisclaimerBox;
